var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPrivate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPrivate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-image1",
    transform: "translate(-220.000000, -42.000000)",
    strokeWidth: 0.3,
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(89.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(29.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(11.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5349574,12.9919444 C94.5349574,13.7927778 93.8906476,14.4444444 93.0988552,14.4444444 L84.9853859,14.4444444 C84.1935934,14.4444444 83.5492837,13.7927778 83.5492837,12.9919444 L83.5492837,7.56361111 C83.5492837,6.76277778 84.1935934,6.11111111 84.9853859,6.11111111 L93.0988552,6.11111111 C93.8906476,6.11111111 94.5349574,6.76277778 94.5349574,7.56361111 L94.5349574,12.9919444 Z M85.1971347,4.02777778 C85.1971347,2.11305556 86.9218855,0.555555556 89.0421205,0.555555556 C91.1623556,0.555555556 92.8871063,2.11305556 92.8871063,4.02777778 L92.8871063,5.55555556 L85.1971347,5.55555556 L85.1971347,4.02777778 Z M93.43639,4.02777778 C93.43639,1.80694444 91.4650109,0 89.0421205,0 C86.6192302,0 84.6478511,1.80694444 84.6478511,4.02777778 L84.6478511,5.58694444 C83.7137941,5.74972222 83,6.57305556 83,7.56388889 L83,12.9922222 C83,14.0991667 83.8906635,15 84.9853859,15 L93.43639,15 C94.5311124,15 95.0842411,14.0991667 95.0842411,12.9919444 L95.0842411,7.56361111 C95.0842411,6.57305556 94.3704469,5.74972222 93.43639,5.58694444 L93.43639,4.02777778 Z",
    id: "icPrivate"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivate);
export default __webpack_public_path__ + "static/media/icPrivate.188e221bd302f8dcd526bea9c1d939b0.svg";
export { ForwardRef as ReactComponent };